<ng-container *ngIf="!contactTypeForm || loading">
    <acabim-loading-view></acabim-loading-view>
</ng-container>

<ng-container *ngIf="contactTypeForm && !loading">
    <form [formGroup]="contactTypeForm">
        <acabim-form-block
                *ngIf="showStep1"
                labelWidth="7"
                class="cas-form-floating push-up-2"
                [labelAlign]="'right'"
                [colonize]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Name</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <input type="text" formControlName="name" id="contact-type-name">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Description</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" formControlName="description" id="contact-type-description">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="contactTypeDetails?.status === 0">
                <acabim-form-input-label>Active</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox formControlName="status" [binary]="true"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="onCancel()">Cancel</button>
                <button (click)="onContactTypeDeleteSubmit()">Remove</button>
                <button class="cas-button-action cas-button-right" (click)="go(2)">Next</button>
            </div>
        </acabim-form-block>
        <acabim-form-block
                *ngIf="showStep2 && !loading && roleCheckboxes.length > 0"
                labelWidth="10"
                [labelAlign]="'right'"
                [colonize]="true"
                [shortFields]="true">
            <p-confirmDialog
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    acceptButtonStyleClass="cas-button-action"></p-confirmDialog>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Roles</acabim-form-input-label>
                <acabim-form-input-content class="role-groups">
                    <ng-container *ngFor="let roleGroup of roleGroups">
                        <acabim-card [cardContent]="roleTemplate" cardHeading="{{roleGroup.name}}" class="role-group-card"></acabim-card>
                        <ng-template #roleTemplate>
                            <div class="roles">
                                <div *ngFor="let role of roleGroup.roles; let i=index" class="checkbox">
                                    <input
                                            type="checkbox"
                                            [value]="role.id"
                                            [pTooltip]="role.long_description"
                                            (change)="onRoleChange(role.id)"
                                            [checked]="roleCheckboxes[role.id] === true" />
                                    {{role.description}}
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="go(1)">Previous</button>
                <button (click)="onCancel()">Cancel</button>
                <button class="cas-button-action cas-button-left" (click)="onContactTypeUpdateSubmit()">Update</button>
            </div>
        </acabim-form-block>
    </form>
</ng-container>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>


<acabim-modal
        [display]="removeContactTypeModal"
        [title]="'Remove contact type'"
        (status)="setRemoveContactTypeModal($event)"
        [footer]="false"
        width="80vw"
        fixHeight="80vh">
    <acabim-admin-remove-contact-type
            *ngIf="removeContactTypeModal"
            [contactTypeDetails]="contactTypeDetails"
            (completed)="onRemoveCompletion($event)">
    </acabim-admin-remove-contact-type>
</acabim-modal>
